import { PlusIcon, XIcon } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

/**
 * Emailovi ostalih članova seanse (partner, porodica), do `maxExtra` redova.
 * Provjera je normalizeMemberEmails (src/lib/session-members.ts) pri slanju.
 */
export function MemberEmailsField({
  value,
  onChange,
  maxExtra,
  label = "Ostali članovi (nije obavezno)",
  readOnly = false,
}: {
  value: string[];
  onChange: (v: string[]) => void;
  maxExtra: number;
  label?: string;
  readOnly?: boolean;
}) {
  const rows = value.length === 0 && !readOnly ? [""] : value;
  const setRow = (i: number, email: string) => onChange(rows.map((r, j) => (j === i ? email : r)));
  const removeRow = (i: number) => onChange(rows.filter((_, j) => j !== i));

  return (
    <div className="space-y-2">
      <Label>{label}</Label>
      {rows.map((email, i) => (
        <div key={i} className="flex items-center gap-2">
          <Input
            type="email"
            inputMode="email"
            autoComplete="off"
            placeholder="email@primjer.ba"
            value={email}
            readOnly={readOnly}
            onChange={(e) => setRow(i, e.target.value)}
            aria-label={`Email člana ${i + 1}`}
          />
          {!readOnly && (rows.length > 1 || email !== "") && (
            <Button type="button" variant="ghost" size="icon" onClick={() => removeRow(i)} aria-label="Ukloni člana">
              <XIcon className="size-4" />
            </Button>
          )}
        </div>
      ))}
      {!readOnly && rows.length < maxExtra && (
        <Button type="button" variant="outline" size="sm" onClick={() => onChange([...rows, ""])}>
          <PlusIcon className="size-4" />
          Dodaj člana
        </Button>
      )}
      <p className="text-xs text-muted-foreground">
        Dobijaju Meet link i podsjetnike na email. Ne trebaju nalog i ne plaćaju.
      </p>
    </div>
  );
}
